import React from "react";
import { useState } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import Careercardimg from "../../Images/CareerCard.jpg";
import Teamcardimg from "../../Images/Teambuildingimg.png";
import ExecutiveHiringimg from "../../Images/ExecutiveHiringimg.png";
import Executiveimgcardimg from "../../Images/ExecutiveCoachingcard.jpg";
import OnboardingCard from "../../Images/Pre&PostOnboardingCard.png";
import PayrollCard from "../../Images/PayrollCard.png";
import employeeCard from "../../Images/EmployeeBenefits&WellnessCard.png";
import StatutoryAndComplianceCard from "../../Images/Satutory&ComplianceCard.png";
import employeeEngCard from "../../Images/Employee_Benefits&Wellness.png";
import PerformanceCard from "../../Images/PerformanceManagementCard.png";
import AIPoweredExamPrepCard from "../../Images/AIPoweredExamPrepCard.png";
import AIPoweredPsychometricTestsCard from "../../Images/AIPoweredPsychometricTestsCard.png";
import FinancialPlanningCard from "../../Images/FinancialPlanningCard.png";
import PersonalCounsellingCard from "../../Images/PersonalCounsellingCard.png";
import SkillBuildingCard from "../../Images/SkillBuildingCard.png";
import StudyAbroadCard from "../../Images/StudyAbroadCard.png";
import CareerLibraryCard from "../../Images/CareerLibraryCard.png";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import Designfour from "../../AVHRBanner/5.png";
import DesignfourN from "../../AVHRBanner/Performance_Management_Banner.png";

function HomePagetwo() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div
          className="grid homebackground"
          style={{
            minHeight: "80vh",
            backgroundColor: "#0D4C5E",
            // backgroundColor: "#5e8d99"
          }}
        >
          <div className="col-12 md:col-6 flex flex-column justify-content-center px-6">
            <h1
              className="text-xl font-bold text-3xl sm:text-7xl"
              style={{ color: "white" }}
            >
              Welcome to AV-CS
            </h1>
            <p className="mb-2 text-3xl" style={{ color: "white" }}>
              We are your Growth-Catalyst
            </p>
            <div className="flex justify-content-center md:justify-content-start gap-4 mt-2 homeLearnMorebtns">
              <Button
                label="Learn More"
                severity="warning"
                rounded
                onClick={() => handleNavigate("/aboutus")}
                className="p-button-rounded buttonAvhrProject"
              ></Button>

              <Button
                label="Contact Us"
                severity="warning"
                className="buttonAvhrProject"
                rounded
                onClick={() => handleNavigate("/contactus")}
              />
            </div>
          </div>

          <div
            className="col-12 md:col-6"
            style={{
              position: "relative",
              overflow: "hidden",
              borderTopLeftRadius: "8rem",
              borderBottomRightRadius: "8rem",
            }}
          >
            <img
              src={Designfour}
              alt="Notary"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderTopLeftRadius: "8rem",
                borderBottomRightRadius: "8rem",
              }}
            />
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine homepurpose-card"
            style={{
              background: "linear-gradient(-120deg, #FFA94D, #FFE766)",
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
              // marginTop: "-8%",
              borderBottom: "5px solid #6b9eaa",
            }}
          >
            <h1 className="avhrProject-h1 mb-2">Our Purpose</h1>
            <p className="avhrProject-p ml-4 mr-4" style={{ fontSize: "20px" }}>
              Leveraging our deep understanding of people dynamics, we empower
              individuals, teams, organizations, and future generations to
              unlock their full potential and achieve meaningful transformation
            </p>
          </div>
        </div>

        <div className="text-center mb-2 ">
          <h3 className="teamBuildingBottom-h3 mb-2">
            Your Trusted HR Partner
          </h3>
          <p className="avhrProject-p">
            At AV-CS, we specialize in delivering end-to-end HR, Coaching, and
            EduSupport Services that drive individual and organizational growth
          </p>
        </div>
        <div className="px-3 md:px-5 lg:px-6 mt-4 custom-tabview">
          <TabView>
            {/* HR Services */}
            <TabPanel header="HR Services">
              <div className="grid justify-content-center">
                {/* HR Cards */}
                {[
                  {
                    img: ExecutiveHiringimg,
                    alt: "Executive Hiring",
                    title: "Executive Hiring",
                    desc: "Attract and onboard top-tier executives to drive your company’s strategic goals",
                    link: "/ExecutiveHiring",
                  },
                  {
                    img: OnboardingCard,
                    alt: "Pre & Post Onboarding",
                    title: "Pre & Post Onboarding",
                    desc: "Ensure a seamless onboarding experience aligned with your company culture",
                    link: "/PreAndPostOnboarding",
                  },
                  {
                    img: PayrollCard,
                    alt: "Payroll",
                    title: "Payroll",
                    desc: "Efficient and accurate payroll services tailored to your business needs",
                    link: "/Payroll",
                  },
                  {
                    img: employeeEngCard,
                    alt: "Employee Engagement",
                    title: "Employee Engagement",
                    desc: "Boost productivity and morale with targeted employee engagement programs",
                    link: "/EmployeeEngagement",
                  },
                  {
                    img: PerformanceCard,
                    alt: "Performance Management",
                    title: "Performance Management",
                    desc: "Implement structured reviews and performance enhancement strategies",
                    link: "/PerformanceManagement",
                  },
                  {
                    img: employeeCard,
                    alt: "Employee Benefits & Wellness",
                    title: "Employee Benefits & Wellness",
                    desc: "Provide holistic well-being and benefit programs for your workforce",
                    link: "/EmployeeBenefitsAndWellnessPortal",
                  },
                  {
                    img: StatutoryAndComplianceCard,
                    alt: "Statutory & Compliance",
                    title: "Statutory & Compliance",
                    desc: "Stay compliant with up-to-date regulatory and statutory obligations",
                    link: "/StatutoryAndCompliance",
                  },
                ].map((service, index) => (
                  <div
                    key={index}
                    className="col-12 md:col-6 lg:col-3 mb-4 flex align-items-stretch"
                  >
                    <div className="p-2 shadow-2 text-center border-round-lg h-full card-hover-effect flex flex-column">
                      {/* Card Content */}
                      <div className="flex-grow-1">
                        <img
                          src={service.img}
                          alt={service.alt}
                          className="w-full border-round-lg mb-3"
                        />
                        <h3 className="mb-2 avhrProject-h3">{service.title}</h3>
                        <p className="mb-2 avhrProject-p">{service.desc}</p>
                      </div>
                      {/* Button Fixed at Bottom */}
                      <div className="mt-auto">
                        <Button
                          label="Read more"
                          text
                          className="p-button-rounded buttonAvhrProject"
                          onClick={() => {
                            navigate(service.link);
                            window.scrollTo(0, 0);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabPanel>

            {/* Coaching & Facilitation */}
            <TabPanel header="Coaching & Facilitation">
              <div className="grid justify-content-center">
                {[
                  {
                    img: Executiveimgcardimg,
                    alt: "Facilitation",
                    title: "Executive Coaching",
                    desc: "Empower leaders with personalized coaching to enhance decision-making and strategic thinking",
                    link: "/ExecutiveCoaching",
                  },

                  {
                    img: Careercardimg,
                    alt: "Career Transition",
                    title: "Career Transition",
                    desc: "Support professionals in navigating career changes with confidence and clarity",
                    link: "/CareerTransition",
                  },
                  {
                    img: Teamcardimg,
                    alt: "Team Building",
                    title: "Team Building",
                    desc: "Foster collaboration and communication with engaging team-building sessions",
                    link: "/Teambuilding",
                  },
                ].map((service, index) => (
                  <div
                    key={index}
                    className="col-12 md:col-6 lg:col-3 mb-4 flex align-items-stretch"
                  >
                    <div className="p-2 shadow-2 text-center border-round-lg h-full card-hover-effect flex flex-column">
                      {/* Card Content */}
                      <div className="flex-grow-1">
                        <img
                          src={service.img}
                          alt={service.alt}
                          className="w-full border-round-lg mb-3"
                        />
                        <h3 className="mb-2 avhrProject-h3">{service.title}</h3>
                        <p className="mb-2 avhrProject-p">{service.desc}</p>
                      </div>
                      {/* Button Fixed at Bottom */}
                      <div className="mt-auto">
                        <Button
                          label="Read more"
                          text
                          className="p-button-rounded buttonAvhrProject"
                          onClick={() => {
                            navigate(service.link);
                            window.scrollTo(0, 0);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabPanel>

            {/* EduSupport */}
            <TabPanel header="EduSupport">
              <div className="grid justify-content-center">
                {[
                  {
                    img: AIPoweredPsychometricTestsCard,
                    alt: "AI Powered Psychometric Tests",
                    title: "AI Powered Psychometric Tests",
                    desc: "Use AI tools to assess aptitude, personality, and career fit",
                    link: "/AIpsychotest",
                  },
                  {
                    img: PersonalCounsellingCard,
                    alt: "Personal Counselling",
                    title: "Personal Counselling",
                    desc: "Provide one-on-one student support for mental and emotional health",
                    link: "/PersonalCounselling",
                  },
                  {
                    img: SkillBuildingCard,
                    alt: "Skill Building",
                    title: "Skill Building",
                    desc: "Build essential life and academic skills for long-term success",
                    link: "/SkillBuilding",
                  },
                  // {
                  //   img: AIPoweredExamPrepCard,
                  //   alt: "AI Powered Exam Prep",
                  //   title: "AI Powered Exam Prep",
                  //   desc: "Customized, AI-driven learning plans for competitive exam success.",
                  //   link: "/ExamPrep",
                  // },
                  {
                    img: FinancialPlanningCard,
                    alt: "Financial Planning",
                    title: "Financial Planning",
                    desc: "Smart financial advice for students pursuing higher education",
                    link: "/FinancialPlanning",
                  },
                  {
                    img: StudyAbroadCard,
                    alt: "Study Abroad",
                    title: "Study Abroad",
                    desc: "Comprehensive guidance for overseas education planning",
                    link: "/StudyAbroad",
                  },
                  {
                    img: CareerLibraryCard,
                    alt: "Career Library",
                    title: "Career Library",
                    desc: "Explore a wide range of career options and paths",
                    link: "/CareerLibrary",
                  },
                ].map((service, index) => (
                  <div
                    key={index}
                    className="col-12 md:col-6 lg:col-3 mb-4 flex align-items-stretch"
                  >
                    <div className="p-2 shadow-2 text-center border-round-lg h-full card-hover-effect flex flex-column">
                      {/* Card Content */}
                      <div className="flex-grow-1">
                        <img
                          src={service.img}
                          alt={service.alt}
                          className="w-full border-round-lg mb-3"
                        />
                        <h3 className="mb-2 avhrProject-h3">{service.title}</h3>
                        <p className="mb-2 avhrProject-p">{service.desc}</p>
                      </div>
                      {/* Button Fixed at Bottom */}
                      <div className="mt-auto">
                        <Button
                          label="Read more"
                          text
                          className="p-button-rounded buttonAvhrProject"
                          onClick={() => {
                            navigate(service.link);
                            window.scrollTo(0, 0);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabPanel>
          </TabView>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            // className="CARDCOLOUR "
            style={{
              backgroundImage: `url(${DesignfourN})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* <p className="mb-2 text-start avhrProject-p text-white">
              CALL BACK
            </p> */}
            <h2 className="mb-2 text-center avhrProject-h2 text-white">
              AV-CS – your Growth Accelerator
            </h2>
            <p className="mb-2 text-center avhrProject-p text-white">
              We enable you and empower you
            </p>
            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default HomePagetwo;
